var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_cart)?_c('v-dialog',{staticStyle:{"z-index":"99"},attrs:{"fullscreen":"","scrollable":"","transition":"dialog-bottom-transition","overlay":false}},[_c('Cart')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }